import React from "react";

const BriefCase = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M13.2 21.2V26h9.6v-4.8H34v11.2a1.6 1.6 0 01-1.6 1.6H3.6A1.6 1.6 0 012 32.4V21.2h11.2zm3.2-3.2h3.2v4.8h-3.2V18zM10 8.4V3.6A1.6 1.6 0 0111.6 2h12.8A1.6 1.6 0 0126 3.6v4.8h6.4A1.6 1.6 0 0134 10v8H22.8v-3.2h-9.6V18H2v-8a1.6 1.6 0 011.6-1.6H10zm3.2-3.2v3.2h9.6V5.2h-9.6z"
            fill={fill}
        />
    </svg>
);

export default BriefCase;
